import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import cn from 'classnames';

import { createStructuredSelector } from 'reselect';
import { Left } from '../../NavBar/NavBar';
import { logout } from '../../../../../../modules/Api/actions';
import { makeSelectLocale } from '../../../../../LanguageProvider/selectors';
import { selectUI } from '../../../../selectors';
import { selectIsLoggedIn, selectUserRights } from '../../../../../../modules/Api/selectors';

import styles from './burger.module.css';

const BurgerComp = ({ isLoggedIn, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleBurger = () => {
    setIsOpen(!isOpen);
  };

  if (!isLoggedIn) return null;

  const NavBarStyles = cn(styles.NavBar, isOpen && window.innerWidth <= 1440 && styles.NavBarOpacity);
  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.BurgerButton} onClick={toggleBurger}>
          <div className={styles.BurgerWrapper}>
            <div className={styles.BurgerLine}></div>
            <div className={styles.BurgerLine}></div>
            <div className={styles.BurgerLine}></div>
          </div>
        </div>
      </div>

      {isOpen && <div className={styles.Backdrop} onClick={() => setIsOpen(false)} />}
      <div className={NavBarStyles}>
        <Left isOpen={isOpen} onClose={() => setIsOpen(false)}>
          {children}
        </Left>
      </div>
    </>
  );
};

BurgerComp.propTypes = {
  isLoggedIn: PropTypes.bool,
  children: PropTypes.node,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    isLoggedIn: selectIsLoggedIn(),
    rights: selectUserRights(),
    UI: selectUI(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    logout() {
      dispatch(logout());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Burger = compose(withConnect, withRouter)(BurgerComp);
